import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "@phosphor-icons/react";

// Connects the Memory Lane section across institution & alumni pages.
export default function MemoryLanePromo({ label, className = "" }) {
  return (
    <Link
      to="/memory-lane"
      data-testid="memory-lane-promo"
      className={`group block overflow-hidden rounded-[2rem] border border-[#c9b48c]/50 bg-[#efe7d6] shadow-sm transition-shadow hover:shadow-md ${className}`}
    >
      <div className="grid items-stretch md:grid-cols-2">
        <div className="relative h-56 md:h-full">
          <img src="/memory-lane-illustration.webp" alt="School & College Memory Lane" className="h-full w-full object-cover" loading="lazy" />
        </div>
        <div className="flex flex-col justify-center gap-3 p-8 sm:p-10">
          <p className="overline inline-flex items-center gap-1.5 text-[#8a6d3b]"><Clock size={14} weight="duotone" /> School · College Memory Lane</p>
          <h3 className="font-heading text-2xl font-light leading-tight tracking-tight text-[#4a3a22] sm:text-3xl">
            Remembering the days <span className="italic font-medium">that shaped us.</span>
          </h3>
          <p className="text-sm leading-relaxed text-[#6b5836]">
            Add old photographs, uniforms, classrooms, trophies and stories{label ? ` from ${label}` : ""} — and reconnect with the people who were there. Every memory becomes part of a living archive for the next generation.
          </p>
          <span className="mt-1 inline-flex items-center gap-1.5 text-sm font-medium text-[#8a6d3b] group-hover:gap-2.5" style={{ transition: "gap 0.2s" }}>
            Visit Memory Lane <ArrowRight size={16} />
          </span>
        </div>
      </div>
    </Link>
  );
}
